const REPORT_GROUP_BY_ENUM = {
  // RegCart
  ORDER_ID: 'order_id',
  CART_ID: 'cart_id',

  // SUBMISSION
  PERIOD: 'period',
  DIVISION: 'division',
  TEAM: 'team',
  REGISTRATION_ID: 'registration_id'
};

const REPORT_RESOURCE_TYPE_ENUM = {
  ORDER: 'order',
  REGISTRATION: 'registration',
  MERCH: 'merch'
};

const REPORT_HEADER_ENUM = {
  DATE: 'date',
  CART_ID: 'cart_id',
  MERCH_ORDER_ID: 'merch_order_id',

  // CUSTOMER
  CUSTOMER_EMAIL: 'customer_email',
  CUSTOMER_NAME: 'customer_name',
  CUSTOMER_PHONE: 'customer_phone',
  CUSTOMER_COUNT: 'customer_count',
  IS_RETURNING: 'is_returning',
  FIRST_ORDER_DATE: 'first_order_date',
  LAST_ORDER_DATE: 'last_order_date',

  // SHIPPING
  SHIPPING_ADDRESS: 'shipping_address',
  SHIPPING_CITY: 'shipping_city',
  SHIPPING_PROVINCE: 'shipping_province',
  SHIPPING_POSTAL_CODE: 'shipping_postal_code',
  SHIPPING_COUNTRY: 'shipping_country',

  // SEASON
  SEASON_NAME: 'season_name',
  SEASON_END_DATE: 'season_end_date',

  // DIVISION
  DIVISION_NAME: 'division_name',
  MIN_DOB: 'min_dob',
  MAX_DOB: 'max_dob',

  // TEAM
  TEAM_NAME: 'team_name',

  // PLAYER
  PLAYER_NAME: 'player_name',
  FIRST_NAME: 'first_name',
  LAST_NAME: 'last_name',
  ROLE: 'role',
  GENDER: 'gender',
  BIRTH_DATE: 'birth_date',
  EMAIL: 'email',
  PHONE: 'phone',
  ADDRESS: 'address',
  CITY: 'city',
  PROVINCE: 'province',
  POSTAL_CODE: 'postal_code',
  COUNTRY: 'country',
  REGISTRATION_AGE: 'registration_age',

  // GUARDIAN
  CONTACT_NAME: 'contact_name',
  CONTACT_PHONE: 'contact_phone',
  CONTACT_EMAIL: 'contact_email',

  // REGISTRATION
  REGISTRATION_ID: 'registration_id',
  FORM_NAME: 'form_name',
  REGISTRATION_STATUS: 'registration_status',
  REGISTRATION_DATE: 'registration_date',

  // PRODUCT
  PRODUCT_TITLE: 'product_title',
  PRODUCT_NAME: 'product_name',
  VARIANT_NAME: 'variant_name',
  ORDERED_QUANTITY: 'ordered_quantity',
  AVERAGE_UNITS_ORDERED: 'average_units_ordered',
  REFUNDED_UNITS: 'refunded_units',
  REFUND_RATE: 'refund_rate',
  NET_QUANTITY: 'net_quantity',

  // CART_BALANCE
  REGISTRATION_COUNT: 'registration_count',
  MERCH_COUNT: 'merch_count',
  NET_SALES: 'net_sales',
  GROSS_SALES: 'gross_sales',
  DISCOUNTS: 'discounts',
  SHIPPING_COST: 'shipping_cost',
  TAXES: 'taxes',
  MERCH_PLATFORM_FEE: 'merch_platform_fee',
  TOTAL_SALES: 'total_sales',
  AMOUNT_PAID: 'amount_paid',
  AMOUNT_REFUNDED: 'amount_refunded',
  REFUND_DATE: 'refund_date',
  SERVICE_FEES: 'service_fees',
  PRODUCT_COST: 'product_cost',
  NET_PROFIT: 'net_profit',
  GROSS_MARGIN: 'gross_margin',
  AVERAGE_COST: 'average_cost',
  UNPAID_BALANCE: 'unpaid_balance',
  REMAINING_BALANCE: 'remaining_balance',
  OVERPAID_BALANCE: 'overpaid_balance',
  CURRENCY: 'currency',
  PAYMENT_TYPE: 'payment_type',
  COUPON: 'coupon',
  FINANCIAL_ASSISTANCE_PROVIDER: 'financial_assistance_provider',
  FINANCIAL_ASSISTANCE_ID: 'financial_assistance_id',
  FINANCIAL_ASSISTANCE_AMOUNT: 'financial_assistance_amount',
  ORDER_COUNT: 'order_count',
  AVERAGE_ORDER_VALUE: 'average_order_value',
  PURCHASE_DATE: 'purchase_date',

  // INSTALLMENTS
  INSTALLMENT_COUNT: 'installment_count',
  INSTALLMENT_COUNT_PAID: 'installment_count_paid',
  INSTALLMENT_COUNT_FAILED: 'installment_count_failed',
  INSTALLMENT_AMOUNT_PENDING: 'installment_amount_pending',
  INSTALLMENT_AMOUNT_PAID: 'installment_amount_paid',
  INSTALLMENT_AMOUNT_REFUNDED: 'installment_amount_refunded',
  INSTALLMENT_DATES: 'installment_dates',
  INSTALLMENT_SCHEDULE: 'installment_schedule',
  NEXT_INSTALLMENT_DATE: 'next_installment_date',
  INSTALLMENT_ATTEMPT_COUNT: 'installment_attempt_count',
  INSTALLMENT_ATTEMPT_COUNT_SUCCEEDED: 'installment_attempt_count_succeeded',
  INSTALLMENT_ATTEMPT_COUNT_FAILED: 'installment_attempt_count_failed',
  INSTALLMENT_FAILURE_REASONS: 'installment_failure_reasons',

  // MERCH
  STORE: 'store',
  MERCH_PRODUCT: 'merch_product',
  PURCHASED_QUANTITY: 'purchased_quantity',
  MERCH_PROFIT: 'merch_profit',
  FILFILLMENT_STATUS: 'fulfillment_status',

  // ADMIN
  ASSOCIATION_NAME: 'association_name',
  SPORTSHEADZ_CREDIT: 'sportsheadz_credit',
  SPORTSHEADZ_PROFIT: 'sportsheadz_profit',
  CALL_TO_ACTION: 'call_to_action'
};

const REPORT_HEADER_TYPE_ENUM = {
  CURRENCY: 1,
  NUMBER: 2,
  STRING: 3,
  DATE: 4,
  BOOLEAN: 5
};

const REPORT_FIELD_COMPARE_VALUES = {
  IS: 'is',
  IS_NOT: 'is_not',
  IN: 'in',
  IS_NOT_IN: 'is_not_in',
  CONTAINS: 'contains',
  DOES_NOT_CONTAIN: 'does_not_contain',
  GREATER_THAN: 'greater_than',
  GREATER_THAN_OR_EQUAL: 'greater_than_or_equal',
  LESS_THAN: 'less_than',
  LESS_THAN_OR_EQUAL: 'less_than_or_equal'
};

const REPORT_FIELD_COMPARE_OPTIONS = [
  { value: REPORT_FIELD_COMPARE_VALUES.IS, label: 'Is' },
  { value: REPORT_FIELD_COMPARE_VALUES.IS_NOT, label: 'Is not' },
  {
    value: REPORT_FIELD_COMPARE_VALUES.IN,
    label: 'In',
    bounds: [REPORT_HEADER_TYPE_ENUM.STRING]
  },
  {
    value: REPORT_FIELD_COMPARE_VALUES.IS_NOT_IN,
    label: 'Is not in',
    bounds: [REPORT_HEADER_TYPE_ENUM.STRING]
  },
  {
    value: REPORT_FIELD_COMPARE_VALUES.CONTAINS,
    label: 'Contains',
    bounds: [REPORT_HEADER_TYPE_ENUM.STRING]
  },
  {
    value: REPORT_FIELD_COMPARE_VALUES.DOES_NOT_CONTAIN,
    label: 'Does not contain',
    bounds: [REPORT_HEADER_TYPE_ENUM.STRING]
  },
  {
    value: REPORT_FIELD_COMPARE_VALUES.GREATER_THAN,
    label: 'Greater than',
    bounds: [
      REPORT_HEADER_TYPE_ENUM.NUMBER,
      REPORT_HEADER_TYPE_ENUM.CURRENCY,
      REPORT_HEADER_TYPE_ENUM.DATE
    ]
  },
  {
    value: REPORT_FIELD_COMPARE_VALUES.GREATER_THAN_OR_EQUAL,
    label: 'Greater than or equal',
    bounds: [
      REPORT_HEADER_TYPE_ENUM.NUMBER,
      REPORT_HEADER_TYPE_ENUM.CURRENCY,
      REPORT_HEADER_TYPE_ENUM.DATE
    ]
  },
  {
    value: REPORT_FIELD_COMPARE_VALUES.LESS_THAN,
    label: 'Less than',
    bounds: [
      REPORT_HEADER_TYPE_ENUM.NUMBER,
      REPORT_HEADER_TYPE_ENUM.CURRENCY,
      REPORT_HEADER_TYPE_ENUM.DATE
    ]
  },
  {
    value: REPORT_FIELD_COMPARE_VALUES.LESS_THAN_OR_EQUAL,
    label: 'Less than or equal',
    bounds: [
      REPORT_HEADER_TYPE_ENUM.NUMBER,
      REPORT_HEADER_TYPE_ENUM.CURRENCY,
      REPORT_HEADER_TYPE_ENUM.DATE
    ]
  }
];

const REPORT_FIELD_LOGIC_OPERATORS = [
  {
    value: 'and',
    label: 'And',
    blockedBounds: [REPORT_FIELD_COMPARE_VALUES.IS]
  },
  {
    value: 'or',
    label: 'Or',
    blockedBounds: [REPORT_FIELD_COMPARE_VALUES.IS_NOT]
  }
];

const REPORT_HEADER_LIST = [
  // CUSTOMER
  {
    value: REPORT_HEADER_ENUM.CUSTOMER_EMAIL,
    label: 'Customer email',
    category: 'Customer'
  },
  {
    value: REPORT_HEADER_ENUM.CUSTOMER_NAME,
    label: 'Customer name',
    category: 'Customer'
  },
  {
    value: REPORT_HEADER_ENUM.CUSTOMER_PHONE,
    label: 'Customer phone',
    category: 'Customer'
  },
  {
    value: REPORT_HEADER_ENUM.CUSTOMER_COUNT,
    label: 'Customer count',
    category: 'Customer'
  },
  {
    value: REPORT_HEADER_ENUM.IS_RETURNING,
    label: 'Is returning customer',
    category: 'Customer'
  },
  {
    value: REPORT_HEADER_ENUM.FIRST_ORDER_DATE,
    label: 'First order date',
    category: 'Customer'
  },
  {
    value: REPORT_HEADER_ENUM.LAST_ORDER_DATE,
    label: 'Last order date',
    category: 'Customer'
  },

  // SHIPPING
  {
    value: REPORT_HEADER_ENUM.SHIPPING_ADDRESS,

    label: 'Shipping address',
    category: 'Shipping'
  },
  {
    value: REPORT_HEADER_ENUM.SHIPPING_CITY,
    label: 'Shipping city',
    category: 'Shipping'
  },
  {
    value: REPORT_HEADER_ENUM.SHIPPING_PROVINCE,
    label: 'Shipping province',
    category: 'Shipping'
  },
  {
    value: REPORT_HEADER_ENUM.SHIPPING_POSTAL_CODE,
    label: 'Shipping postal code',
    category: 'Shipping'
  },
  {
    value: REPORT_HEADER_ENUM.SHIPPING_COUNTRY,
    label: 'Shipping country',
    category: 'Shipping'
  },

  // SEASON
  {
    value: REPORT_HEADER_ENUM.SEASON_NAME,
    label: 'Season name',
    category: 'Season'
  },
  {
    value: REPORT_HEADER_ENUM.SEASON_END_DATE,
    label: 'Season end date',
    category: 'Season'
  },

  // DIVISION
  {
    value: REPORT_HEADER_ENUM.DIVISION_NAME,
    label: 'Division name',
    category: 'Division'
  },
  {
    value: REPORT_HEADER_ENUM.MIN_DOB,
    label: 'Min DOB',
    category: 'Division'
  },
  {
    value: REPORT_HEADER_ENUM.MAX_DOB,
    label: 'Max DOB',
    category: 'Division'
  },

  // TEAM
  {
    value: REPORT_HEADER_ENUM.TEAM_NAME,
    label: 'Team name',
    category: 'Team'
  },

  // PLAYER
  {
    value: REPORT_HEADER_ENUM.PLAYER_NAME,
    label: 'Player name',
    category: 'Player'
  },
  {
    value: REPORT_HEADER_ENUM.FIRST_NAME,
    label: 'First name',
    category: 'Player'
  },
  {
    value: REPORT_HEADER_ENUM.LAST_NAME,
    label: 'Last name',
    category: 'Player'
  },
  {
    value: REPORT_HEADER_ENUM.ROLE,
    label: 'Role',
    category: 'Player'
  },
  {
    value: REPORT_HEADER_ENUM.GENDER,
    label: 'Gender',
    category: 'Player'
  },
  {
    value: REPORT_HEADER_ENUM.BIRTH_DATE,
    label: 'Birth date',
    category: 'Player'
  },
  {
    value: REPORT_HEADER_ENUM.EMAIL,
    label: 'Email',
    category: 'Player'
  },
  {
    value: REPORT_HEADER_ENUM.PHONE,
    label: 'Phone',
    category: 'Player'
  },
  {
    value: REPORT_HEADER_ENUM.ADDRESS,
    label: 'Address',
    category: 'Player'
  },
  {
    value: REPORT_HEADER_ENUM.CITY,
    label: 'City',
    category: 'Player'
  },
  {
    value: REPORT_HEADER_ENUM.PROVINCE,
    label: 'Province',
    category: 'Player'
  },
  {
    value: REPORT_HEADER_ENUM.POSTAL_CODE,
    label: 'Postal code',
    category: 'Player'
  },
  {
    value: REPORT_HEADER_ENUM.COUNTRY,
    label: 'Country',
    category: 'Player'
  },
  {
    value: REPORT_HEADER_ENUM.REGISTRATION_AGE,
    label: 'Registration age',
    category: 'Player'
  },

  // GUARDIAN
  {
    value: REPORT_HEADER_ENUM.CONTACT_NAME,
    label: 'Contact name',
    category: 'Parent'
  },
  {
    value: REPORT_HEADER_ENUM.CONTACT_PHONE,
    label: 'Contact phone',
    category: 'Parent'
  },
  {
    value: REPORT_HEADER_ENUM.CONTACT_EMAIL,
    label: 'Contact email',
    category: 'Parent'
  },

  // REGISTRATION
  {
    value: REPORT_HEADER_ENUM.REGISTRATION_ID,
    label: 'Registration ID',
    category: 'Registration'
  },
  {
    value: REPORT_HEADER_ENUM.FORM_NAME,
    label: 'Form name',
    category: 'Registration'
  },
  {
    value: REPORT_HEADER_ENUM.REGISTRATION_STATUS,
    label: 'Registration status',
    category: 'Registration'
  },
  {
    value: REPORT_HEADER_ENUM.REGISTRATION_DATE,
    label: 'Registration date',
    category: 'Registration'
  },

  // PRODUCT
  {
    value: REPORT_HEADER_ENUM.PRODUCT_ID,
    label: 'Product ID',
    category: 'Product'
  },
  {
    value: REPORT_HEADER_ENUM.PRODUCT_TITLE,
    label: 'Product title',
    category: 'Product'
  },
  {
    value: REPORT_HEADER_ENUM.PRODUCT_NAME,
    label: 'Product name',
    category: 'Product'
  },
  {
    value: REPORT_HEADER_ENUM.VARIANT_NAME,
    label: 'Variant name',
    category: 'Product'
  },
  {
    value: REPORT_HEADER_ENUM.ORDERED_QUANTITY,
    label: 'Ordered quantity',
    category: 'Product'
  },
  {
    value: REPORT_HEADER_ENUM.AVERAGE_UNITS_ORDERED,
    label: 'Average units ordered',
    category: 'Product'
  },
  {
    value: REPORT_HEADER_ENUM.REFUNDED_UNITS,
    label: 'Refunded units',
    category: 'Product'
  },
  {
    value: REPORT_HEADER_ENUM.REFUND_RATE,
    label: 'Refund rate',
    category: 'Product'
  },
  {
    value: REPORT_HEADER_ENUM.NET_QUANTITY,
    label: 'Net quantity',
    category: 'Product'
  },

  // CART_BALANCE
  {
    value: REPORT_HEADER_ENUM.REGISTRATION_COUNT,
    label: 'Registration count',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.MERCH_COUNT,
    label: 'Merch count',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.NET_SALES,
    label: 'Net sales',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.GROSS_SALES,
    label: 'Gross sales',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.DISCOUNTS,
    label: 'Discounts',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.SHIPPING_COST,
    label: 'Shipping cost',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.TAXES,
    label: 'Taxes',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.MERCH_PLATFORM_FEE,
    label: 'Merch platform fee',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.TOTAL_SALES,
    label: 'Total sales',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.AMOUNT_PAID,
    label: 'Amount paid',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.AMOUNT_REFUNDED,
    label: 'Amount refunded',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.REFUND_DATE,
    label: 'Refund date',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.SERVICE_FEES,
    label: 'Service fees',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.PRODUCT_COST,
    label: 'Product cost',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.NET_PROFIT,
    label: 'Net profit',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.GROSS_MARGIN,
    label: 'Gross margin',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.AVERAGE_COST,
    label: 'Average cost',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.UNPAID_BALANCE,
    label: 'Unpaid balance',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.REMAINING_BALANCE,
    label: 'Remaining balance',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.OVERPAID_BALANCE,
    label: 'Overpaid balance',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.CURRENCY,
    label: 'Currency',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.PAYMENT_TYPE,
    label: 'Payment type',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.COUPON,
    label: 'Coupon',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.FINANCIAL_ASSISTANCE_PROVIDER,
    label: 'Financial assistance provider',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.FINANCIAL_ASSISTANCE_ID,
    label: 'Financial assistance ID',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.FINANCIAL_ASSISTANCE_AMOUNT,
    label: 'Financial assistance amount',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.ORDER_COUNT,
    label: 'Order count',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.AVERAGE_ORDER_VALUE,
    label: 'Average order value',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.PURCHASE_DATE,
    label: 'Purchase date',
    category: 'Transaction'
  },

  // INSTALLMENTS
  {
    value: REPORT_HEADER_ENUM.INSTALLMENT_COUNT,
    label: 'Installment count',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.INSTALLMENT_COUNT_PAID,
    label: 'Installment count paid',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.INSTALLMENT_COUNT_FAILED,
    label: 'Installment count failed',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.INSTALLMENT_AMOUNT_PENDING,
    label: 'Installment amount pending',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.INSTALLMENT_AMOUNT_PAID,
    label: 'Installment amount paid',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.INSTALLMENT_AMOUNT_REFUNDED,
    label: 'Installment amount refunded',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.INSTALLMENT_DATES,
    label: 'Installment dates',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.INSTALLMENT_SCHEDULE,
    label: 'Installment schedule',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.NEXT_INSTALLMENT_DATE,
    label: 'Next installment date',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.INSTALLMENT_ATTEMPT_COUNT,
    label: 'Installment attempt count',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.INSTALLMENT_ATTEMPT_COUNT_SUCCEEDED,
    label: 'Installment attempt count succeeded',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.INSTALLMENT_ATTEMPT_COUNT_FAILED,
    label: 'Installment attempt count failed',
    category: 'Transaction'
  },
  {
    value: REPORT_HEADER_ENUM.INSTALLMENT_FAILURE_REASONS,
    label: 'Installment failure reasons',
    category: 'Transaction'
  },

  // MERCH
  {
    value: REPORT_HEADER_ENUM.STORE,
    label: 'Merch store',
    category: 'Merch'
  },
  {
    value: REPORT_HEADER_ENUM.MERCH_PRODUCT,
    label: 'Merch product',
    category: 'Merch'
  },
  {
    value: REPORT_HEADER_ENUM.PURCHASED_QUANTITY,
    label: 'Purchased quantity',
    category: 'Merch'
  },
  {
    value: REPORT_HEADER_ENUM.MERCH_PROFIT,
    label: 'Merch profit',
    category: 'Merch'
  },
  {
    value: REPORT_HEADER_ENUM.FILFILLMENT_STATUS,
    label: 'Fulfillment status',
    category: 'Merch'
  },

  // ADMIN
  {
    value: REPORT_HEADER_ENUM.ASSOCIATION_NAME,
    label: 'Association name',
    category: 'Admin',
    allowedViews: ['admin']
  },
  {
    value: REPORT_HEADER_ENUM.SPORTSHEADZ_CREDIT,
    label: 'SportsHeadz credit',
    category: 'Admin',
    allowedViews: ['admin']
  },
  {
    value: REPORT_HEADER_ENUM.SPORTSHEADZ_PROFIT,
    label: 'SportsHeadz profit',
    category: 'Admin',
    allowedViews: ['admin']
  },
  {
    value: REPORT_HEADER_ENUM.CALL_TO_ACTION,
    label: 'Call to action',
    category: 'Admin',
    allowedViews: ['admin']
  }
];

const REPORT_CATEGORY_ENUM = {
  SALES: '1',
  CUSTOMERS: '2',
  ORDERS: '3',
  FINANCES: '4'
};

const REPORT_CATEGORY_LIST = [
  {
    label: 'Sales',
    value: REPORT_CATEGORY_ENUM.SALES
  },
  {
    label: 'Customers',
    value: REPORT_CATEGORY_ENUM.CUSTOMERS
  },
  {
    label: 'Orders',
    value: REPORT_CATEGORY_ENUM.ORDERS
  },
  {
    label: 'Finances',
    value: REPORT_CATEGORY_ENUM.FINANCES
  }
];

const DEFAULT_REPORT_HEADERS = [
  // CUSTOMER
  REPORT_HEADER_ENUM.CUSTOMER_EMAIL,
  REPORT_HEADER_ENUM.CUSTOMER_NAME,
  REPORT_HEADER_ENUM.CUSTOMER_PHONE,
  REPORT_HEADER_ENUM.CUSTOMER_COUNT,

  // SEASON
  REPORT_HEADER_ENUM.SEASON_NAME,

  // DIVISION
  REPORT_HEADER_ENUM.DIVISION_NAME,

  // PLAYER
  REPORT_HEADER_ENUM.PLAYER_NAME,
  REPORT_HEADER_ENUM.FIRST_NAME,
  REPORT_HEADER_ENUM.LAST_NAME,
  REPORT_HEADER_ENUM.ROLE,
  REPORT_HEADER_ENUM.GENDER,
  REPORT_HEADER_ENUM.BIRTH_DATE,
  REPORT_HEADER_ENUM.EMAIL,
  REPORT_HEADER_ENUM.PHONE,
  REPORT_HEADER_ENUM.ADDRESS,
  REPORT_HEADER_ENUM.CITY,
  REPORT_HEADER_ENUM.PROVINCE,
  REPORT_HEADER_ENUM.POSTAL_CODE,
  REPORT_HEADER_ENUM.COUNTRY,
  REPORT_HEADER_ENUM.REGISTRATION_AGE,

  // GUARDIAN
  REPORT_HEADER_ENUM.CONTACT_NAME,
  REPORT_HEADER_ENUM.CONTACT_PHONE,
  REPORT_HEADER_ENUM.CONTACT_EMAIL,

  // REGISTRATION
  REPORT_HEADER_ENUM.REGISTRATION_ID,
  REPORT_HEADER_ENUM.FORM_NAME,
  REPORT_HEADER_ENUM.REGISTRATION_STATUS,
  REPORT_HEADER_ENUM.REGISTRATION_DATE,

  // CART_BALANCE
  REPORT_HEADER_ENUM.NET_SALES,
  REPORT_HEADER_ENUM.GROSS_SALES,
  REPORT_HEADER_ENUM.DISCOUNTS,
  REPORT_HEADER_ENUM.TAXES,
  REPORT_HEADER_ENUM.TOTAL_SALES,
  REPORT_HEADER_ENUM.AMOUNT_PAID,
  REPORT_HEADER_ENUM.AMOUNT_REFUNDED,
  REPORT_HEADER_ENUM.REFUND_DATE,
  REPORT_HEADER_ENUM.SERVICE_FEES,
  REPORT_HEADER_ENUM.NET_PROFIT,
  REPORT_HEADER_ENUM.GROSS_MARGIN,
  REPORT_HEADER_ENUM.AVERAGE_COST,
  REPORT_HEADER_ENUM.UNPAID_BALANCE,
  REPORT_HEADER_ENUM.REMAINING_BALANCE,
  REPORT_HEADER_ENUM.OVERPAID_BALANCE,
  REPORT_HEADER_ENUM.CURRENCY,
  REPORT_HEADER_ENUM.PAYMENT_TYPE,
  REPORT_HEADER_ENUM.COUPON,
  REPORT_HEADER_ENUM.FINANCIAL_ASSISTANCE_PROVIDER,
  REPORT_HEADER_ENUM.FINANCIAL_ASSISTANCE_ID,
  REPORT_HEADER_ENUM.FINANCIAL_ASSISTANCE_AMOUNT,
  REPORT_HEADER_ENUM.PURCHASE_DATE,

  // ADMIN
  REPORT_HEADER_ENUM.ASSOCIATION_NAME,
  REPORT_HEADER_ENUM.SPORTSHEADZ_CREDIT,
  REPORT_HEADER_ENUM.SPORTSHEADZ_PROFIT
];

const EXTRA_ORDER_REPORT_HEADERS = [
  // SHIPPING
  REPORT_HEADER_ENUM.SHIPPING_ADDRESS,
  REPORT_HEADER_ENUM.SHIPPING_CITY,
  REPORT_HEADER_ENUM.SHIPPING_PROVINCE,
  REPORT_HEADER_ENUM.SHIPPING_POSTAL_CODE,
  REPORT_HEADER_ENUM.SHIPPING_COUNTRY,

  // PRODUCT
  REPORT_HEADER_ENUM.PRODUCT_TITLE,
  REPORT_HEADER_ENUM.PRODUCT_NAME,
  REPORT_HEADER_ENUM.VARIANT_NAME,
  REPORT_HEADER_ENUM.ORDERED_QUANTITY,
  REPORT_HEADER_ENUM.AVERAGE_UNITS_ORDERED,
  REPORT_HEADER_ENUM.REFUNDED_UNITS,
  REPORT_HEADER_ENUM.REFUND_RATE,
  REPORT_HEADER_ENUM.NET_QUANTITY,

  // CART_BALANCE
  REPORT_HEADER_ENUM.REGISTRATION_COUNT,
  REPORT_HEADER_ENUM.MERCH_COUNT,
  REPORT_HEADER_ENUM.SHIPPING_COST,
  REPORT_HEADER_ENUM.MERCH_PLATFORM_FEE,
  REPORT_HEADER_ENUM.PRODUCT_COST,
  REPORT_HEADER_ENUM.ORDER_COUNT,
  REPORT_HEADER_ENUM.AVERAGE_ORDER_VALUE,

  // INSTALLMENTS
  REPORT_HEADER_ENUM.INSTALLMENT_COUNT,
  REPORT_HEADER_ENUM.INSTALLMENT_COUNT_PAID,
  REPORT_HEADER_ENUM.INSTALLMENT_COUNT_FAILED,
  REPORT_HEADER_ENUM.INSTALLMENT_AMOUNT_PENDING,
  REPORT_HEADER_ENUM.INSTALLMENT_AMOUNT_PAID,
  REPORT_HEADER_ENUM.INSTALLMENT_AMOUNT_REFUNDED,
  REPORT_HEADER_ENUM.INSTALLMENT_DATES,
  REPORT_HEADER_ENUM.INSTALLMENT_SCHEDULE,
  REPORT_HEADER_ENUM.NEXT_INSTALLMENT_DATE,
  REPORT_HEADER_ENUM.INSTALLMENT_ATTEMPT_COUNT,
  REPORT_HEADER_ENUM.INSTALLMENT_ATTEMPT_COUNT_SUCCEEDED,
  REPORT_HEADER_ENUM.INSTALLMENT_ATTEMPT_COUNT_FAILED,
  REPORT_HEADER_ENUM.INSTALLMENT_FAILURE_REASONS,

  // MERCH
  REPORT_HEADER_ENUM.STORE,
  REPORT_HEADER_ENUM.MERCH_PRODUCT,
  REPORT_HEADER_ENUM.PURCHASED_QUANTITY,
  REPORT_HEADER_ENUM.MERCH_PROFIT,
  REPORT_HEADER_ENUM.FILFILLMENT_STATUS,

  // ADMIN
  REPORT_HEADER_ENUM.CALL_TO_ACTION
];

const EXTRA_REGISTRATION_REPORT_HEADERS = [
  // SEASON
  REPORT_HEADER_ENUM.SEASON_END_DATE,

  // DIVISION
  REPORT_HEADER_ENUM.MIN_DOB,
  REPORT_HEADER_ENUM.MAX_DOB,

  // TEAM
  REPORT_HEADER_ENUM.TEAM_NAME
];

const REPORT_TYPE_ENUM = {
  SALES: '1',
  REGISTRATIONS: '2',
  CUSTOMERS: '3',
  ORDERS: '4'
};

const REPORT_TYPE_CONFIG = [
  {
    value: REPORT_TYPE_ENUM.SALES,
    label: 'Sales',
    chartable: true,
    headers: [...DEFAULT_REPORT_HEADERS]
  },
  {
    value: REPORT_TYPE_ENUM.REGISTRATIONS,
    label: 'Registrations',
    chartable: true,
    headers: [...DEFAULT_REPORT_HEADERS, ...EXTRA_REGISTRATION_REPORT_HEADERS]
  },
  {
    value: REPORT_TYPE_ENUM.CUSTOMERS,
    label: 'Customers',
    headers: [...DEFAULT_REPORT_HEADERS]
  },
  {
    value: REPORT_TYPE_ENUM.ORDERS,
    label: 'Orders',
    headers: [...DEFAULT_REPORT_HEADERS, ...EXTRA_ORDER_REPORT_HEADERS]
  }
];

const ECOM_REPORT_ENUM = {
  // OVERVIEW
  OVERVIEW: 'overview',
  FINANCE_SUMMARY: 'finance_summary',

  // DEFAULT REPORTS
  ACCOUNTS_RECEIVABLE: 'accounts_receivable',
  ACCOUNTS_SETTLED: 'accounts_settled',
  DIVISION_TEAMS: 'division_teams',
  FORM_SUBMISSIONS: 'form_submissions',
  INSTALLMENTS: 'installments',
  MERCH_TRANSACTIONS: 'merch_transactions',
  REGISTRANTS: 'registrants',
  SEASON_TEAMS: 'season_teams',
  TEAM_REPORT: 'team_report',

  // FINANCES
  TOTAL_SALES: 'total_sales',

  // ADMIN REPORTS
  ADMIN_MERCH_REPORT: 'admin_merch_report'
};

const DEFAULT_REPORT_CONFIGS = [
  {
    title: 'Accounts Receivable Report',
    description: 'View outstanding registrant payments',
    uuid: ECOM_REPORT_ENUM.ACCOUNTS_RECEIVABLE,
    fkReportType: REPORT_TYPE_ENUM.REGISTRATIONS,
    fkReportCategory: REPORT_CATEGORY_ENUM.SALES,
    defaultHeaders: [
      REPORT_HEADER_ENUM.DIVISION_NAME,
      REPORT_HEADER_ENUM.FIRST_NAME,
      REPORT_HEADER_ENUM.LAST_NAME,
      REPORT_HEADER_ENUM.GENDER,
      REPORT_HEADER_ENUM.BIRTH_DATE,
      REPORT_HEADER_ENUM.REGISTRATION_STATUS,
      REPORT_HEADER_ENUM.REGISTRATION_DATE,
      REPORT_HEADER_ENUM.EMAIL,
      REPORT_HEADER_ENUM.PHONE,
      REPORT_HEADER_ENUM.TOTAL_SALES,
      REPORT_HEADER_ENUM.AMOUNT_PAID,
      REPORT_HEADER_ENUM.REMAINING_BALANCE,
      REPORT_HEADER_ENUM.COUPON,
      REPORT_HEADER_ENUM.FINANCIAL_ASSISTANCE_PROVIDER,
      REPORT_HEADER_ENUM.FINANCIAL_ASSISTANCE_ID
    ],
    groupBy: REPORT_GROUP_BY_ENUM.REGISTRATION_ID,
    noDateRangeEnabled: true,
    resourceSelectEnabled: true,
    compareEnabled: false,
    defaultFilters: [
      {
        field: REPORT_HEADER_ENUM.REGISTRATION_STATUS,
        compare: REPORT_FIELD_COMPARE_VALUES.IS,
        logicalOperator: REPORT_FIELD_LOGIC_OPERATORS[1].value,
        values: ['PENDING PAYMENT']
      }
    ]
  },
  {
    title: 'Accounts Settled',
    description: 'View paid registrants',
    uuid: ECOM_REPORT_ENUM.ACCOUNTS_SETTLED,
    fkReportType: REPORT_TYPE_ENUM.REGISTRATIONS,
    fkReportCategory: REPORT_CATEGORY_ENUM.SALES,
    defaultHeaders: [
      REPORT_HEADER_ENUM.DIVISION_NAME,
      REPORT_HEADER_ENUM.FIRST_NAME,
      REPORT_HEADER_ENUM.LAST_NAME,
      REPORT_HEADER_ENUM.GENDER,
      REPORT_HEADER_ENUM.BIRTH_DATE,
      REPORT_HEADER_ENUM.REGISTRATION_STATUS,
      REPORT_HEADER_ENUM.REGISTRATION_DATE,
      REPORT_HEADER_ENUM.EMAIL,
      REPORT_HEADER_ENUM.PHONE,
      REPORT_HEADER_ENUM.COUPON,
      REPORT_HEADER_ENUM.TOTAL_SALES,
      REPORT_HEADER_ENUM.SERVICE_FEES,
      REPORT_HEADER_ENUM.AMOUNT_REFUNDED,
      REPORT_HEADER_ENUM.REFUND_DATE,
      REPORT_HEADER_ENUM.NET_PROFIT,
      REPORT_HEADER_ENUM.CURRENCY,
      REPORT_HEADER_ENUM.PAYMENT_TYPE
    ],
    groupBy: REPORT_GROUP_BY_ENUM.REGISTRATION_ID,
    noDateRangeEnabled: true,
    resourceSelectEnabled: true,
    compareEnabled: false,
    defaultFilters: [
      {
        field: REPORT_HEADER_ENUM.REGISTRATION_STATUS,
        compare: REPORT_FIELD_COMPARE_VALUES.IS_NOT,
        logicalOperator: REPORT_FIELD_LOGIC_OPERATORS[1].value,
        values: ['PENDING PAYMENT']
      }
    ]
  },
  {
    title: 'Form Submission Report',
    description: 'View registrants who have submitted a form',
    uuid: ECOM_REPORT_ENUM.FORM_SUBMISSIONS,
    fkReportType: REPORT_TYPE_ENUM.REGISTRATIONS,
    fkReportCategory: REPORT_CATEGORY_ENUM.SALES,
    defaultHeaders: [
      REPORT_HEADER_ENUM.DIVISION_NAME,
      REPORT_HEADER_ENUM.FIRST_NAME,
      REPORT_HEADER_ENUM.LAST_NAME,
      REPORT_HEADER_ENUM.GENDER,
      REPORT_HEADER_ENUM.BIRTH_DATE,
      REPORT_HEADER_ENUM.REGISTRATION_STATUS,
      REPORT_HEADER_ENUM.FORM_NAME,
      REPORT_HEADER_ENUM.REGISTRATION_DATE,
      REPORT_HEADER_ENUM.EMAIL,
      REPORT_HEADER_ENUM.PHONE
    ],
    groupBy: REPORT_GROUP_BY_ENUM.REGISTRATION_ID,
    noDateRangeEnabled: true,
    resourceSelectEnabled: true,
    compareEnabled: false,
    defaultFilters: []
  },
  {
    title: 'Registrants Report',
    description: 'View all registrants',
    uuid: ECOM_REPORT_ENUM.REGISTRANTS,
    fkReportType: REPORT_TYPE_ENUM.REGISTRATIONS,
    fkReportCategory: REPORT_CATEGORY_ENUM.SALES,
    defaultHeaders: [
      REPORT_HEADER_ENUM.DIVISION_NAME,
      REPORT_HEADER_ENUM.FIRST_NAME,
      REPORT_HEADER_ENUM.LAST_NAME,
      REPORT_HEADER_ENUM.GENDER,
      REPORT_HEADER_ENUM.BIRTH_DATE,
      REPORT_HEADER_ENUM.REGISTRATION_STATUS,
      REPORT_HEADER_ENUM.REGISTRATION_DATE,
      REPORT_HEADER_ENUM.EMAIL,
      REPORT_HEADER_ENUM.PHONE
    ],
    groupBy: REPORT_GROUP_BY_ENUM.REGISTRATION_ID,
    noDateRangeEnabled: true,
    resourceSelectEnabled: true,
    compareEnabled: false,
    defaultFilters: []
  },
  {
    title: 'Installment Report',
    description: 'View installment payment schedules by order',
    uuid: ECOM_REPORT_ENUM.INSTALLMENTS,
    fkReportType: REPORT_TYPE_ENUM.ORDERS,
    fkReportCategory: REPORT_CATEGORY_ENUM.SALES,
    defaultHeaders: [
      REPORT_HEADER_ENUM.CUSTOMER_NAME,
      REPORT_HEADER_ENUM.CUSTOMER_EMAIL,
      REPORT_HEADER_ENUM.TOTAL_SALES,
      REPORT_HEADER_ENUM.AMOUNT_PAID,
      REPORT_HEADER_ENUM.REMAINING_BALANCE,
      REPORT_HEADER_ENUM.INSTALLMENT_COUNT,
      REPORT_HEADER_ENUM.INSTALLMENT_COUNT_PAID,
      REPORT_HEADER_ENUM.INSTALLMENT_COUNT_FAILED,
      REPORT_HEADER_ENUM.INSTALLMENT_AMOUNT_PAID,
      REPORT_HEADER_ENUM.INSTALLMENT_AMOUNT_PENDING,
      REPORT_HEADER_ENUM.INSTALLMENT_AMOUNT_REFUNDED,
      REPORT_HEADER_ENUM.NEXT_INSTALLMENT_DATE,
      REPORT_HEADER_ENUM.INSTALLMENT_DATES,
      REPORT_HEADER_ENUM.INSTALLMENT_SCHEDULE,
      REPORT_HEADER_ENUM.INSTALLMENT_ATTEMPT_COUNT,
      REPORT_HEADER_ENUM.INSTALLMENT_ATTEMPT_COUNT_SUCCEEDED,
      REPORT_HEADER_ENUM.INSTALLMENT_ATTEMPT_COUNT_FAILED,
      REPORT_HEADER_ENUM.INSTALLMENT_FAILURE_REASONS,
      REPORT_HEADER_ENUM.PAYMENT_TYPE
    ],
    groupBy: REPORT_GROUP_BY_ENUM.CART_ID,
    resourceType: REPORT_RESOURCE_TYPE_ENUM.ORDER,
    noDateRangeEnabled: true,
    compareEnabled: false,
    defaultFilters: [
      {
        field: REPORT_HEADER_ENUM.INSTALLMENT_COUNT,
        compare: REPORT_FIELD_COMPARE_VALUES.GREATER_THAN,
        logicalOperator: REPORT_FIELD_LOGIC_OPERATORS[1].value,
        values: ['0']
      }
    ]
  },
  {
    title: 'Merch Transaction Report',
    description: 'View paid merchandise',
    uuid: ECOM_REPORT_ENUM.MERCH_TRANSACTIONS,
    fkReportType: REPORT_TYPE_ENUM.SALES,
    fkReportCategory: REPORT_CATEGORY_ENUM.SALES,
    defaultHeaders: [
      REPORT_HEADER_ENUM.MERCH_PRODUCT,
      REPORT_HEADER_ENUM.CUSTOMER_NAME,
      REPORT_HEADER_ENUM.CUSTOMER_EMAIL,
      REPORT_HEADER_ENUM.GROSS_SALES,
      REPORT_HEADER_ENUM.SHIPPING_COST,
      REPORT_HEADER_ENUM.MERCH_PLATFORM_FEE,
      REPORT_HEADER_ENUM.TOTAL_SALES,
      REPORT_HEADER_ENUM.SERVICE_FEES,
      REPORT_HEADER_ENUM.AMOUNT_REFUNDED,
      REPORT_HEADER_ENUM.REFUND_DATE,
      REPORT_HEADER_ENUM.PRODUCT_COST,
      REPORT_HEADER_ENUM.NET_PROFIT,
      REPORT_HEADER_ENUM.CURRENCY,
      REPORT_HEADER_ENUM.PAYMENT_TYPE
    ],
    groupBy: REPORT_GROUP_BY_ENUM.CART_ID,
    resourceType: REPORT_RESOURCE_TYPE_ENUM.MERCH,
    noDateRangeEnabled: true,
    compareEnabled: false,
    defaultFilters: []
  },
  {
    title: 'Season Teams Report',
    description: 'View team information by season',
    uuid: ECOM_REPORT_ENUM.SEASON_TEAMS,
    fkReportType: REPORT_TYPE_ENUM.REGISTRATIONS,
    fkReportCategory: REPORT_CATEGORY_ENUM.SALES,
    reportTemplateUuid: 'SEASONS',
    defaultHeaders: [],
    groupBy: REPORT_GROUP_BY_ENUM.PRODUCT_ID,
    compareEnabled: false,
    defaultFilters: []
  },
  {
    title: 'Division Teams Report',
    description: 'View team information by division',
    uuid: ECOM_REPORT_ENUM.DIVISION_TEAMS,
    fkReportType: REPORT_TYPE_ENUM.REGISTRATIONS,
    fkReportCategory: REPORT_CATEGORY_ENUM.SALES,
    reportTemplateUuid: 'DIVISION',
    defaultHeaders: [],
    groupBy: REPORT_GROUP_BY_ENUM.PRODUCT_ID,
    compareEnabled: false,
    defaultFilters: []
  },
  {
    title: 'Team Report',
    description: 'View information by team',
    uuid: ECOM_REPORT_ENUM.TEAM_REPORT,
    fkReportType: REPORT_TYPE_ENUM.REGISTRATIONS,
    fkReportCategory: REPORT_CATEGORY_ENUM.SALES,
    reportTemplateUuid: 'TEAM',
    defaultHeaders: [],
    groupBy: REPORT_GROUP_BY_ENUM.PRODUCT_ID,
    compareEnabled: false,
    defaultFilters: []
  }

  // FINANCES
  // {
  //   title: 'Total sales',
  //   uuid: ECOM_REPORT_ENUM.TOTAL_SALES,
  //   fkReportType: REPORT_TYPE_ENUM.SALES,
  //   fkReportCategory: REPORT_CATEGORY_ENUM.FINANCES,
  //   groupBy: REPORT_GROUP_BY_ENUM.CART_ID,
  //   resourceType: REPORT_RESOURCE_TYPE_ENUM.ORDER,
  //   compareEnabled: false,
  //   defaultHeaders: [
  //     REPORT_HEADER_ENUM.DATE,
  //     REPORT_HEADER_ENUM.CART_ID,
  //     REPORT_HEADER_ENUM.PRODUCT_NAME,
  //     REPORT_HEADER_ENUM.TOTAL_SALES,
  //     REPORT_HEADER_ENUM.AMOUNT_PAID,
  //     REPORT_HEADER_ENUM.AMOUNT_REFUNDED,
  //     REPORT_HEADER_ENUM.SERVICE_FEES,
  //     REPORT_HEADER_ENUM.NET_PROFIT
  //   ]
  // }
];

export {
  REPORT_GROUP_BY_ENUM,
  REPORT_RESOURCE_TYPE_ENUM,
  REPORT_HEADER_ENUM,
  REPORT_HEADER_LIST,
  REPORT_HEADER_TYPE_ENUM,
  REPORT_FIELD_COMPARE_VALUES,
  REPORT_CATEGORY_ENUM,
  REPORT_CATEGORY_LIST,
  REPORT_FIELD_COMPARE_OPTIONS,
  REPORT_FIELD_LOGIC_OPERATORS,
  REPORT_TYPE_ENUM,
  REPORT_TYPE_CONFIG,
  ECOM_REPORT_ENUM,
  DEFAULT_REPORT_CONFIGS
};
